import React from 'react';
import { isNil } from 'lodash';
import AnimateHeight from 'react-animate-height';
import {
  CircularProgress,
  withStyles,
  Typography,
  Button,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

import ListingPreview from '../../../utility/ListingPreview/index';
import NumberElement from '../../../utility/NumberElement/index';
import { percentage, normalizePrice } from '../../../../lib/helpers';
import { isMobile } from '../../../../lib/getDeviceSize';
import styles from './styles';

import style from '../../../../styles/sass/components/CompsChomper.module.scss';

interface Props {
  animateSummaryProps?: any;
  classes: any;
  isSummaryOpen: boolean;
  handleSummaryToggle: Function;
  listing: any;
  loading: boolean;
  soldComps: any;
}

interface State {
  expand: boolean;
  height: any;
}
class Summary extends React.Component<Props, State> {
  state = {
    expand: false,
    height: 75,
  };

  componentDidMount = () => {
    if (
      this.props.animateSummaryProps &&
      this.props.animateSummaryProps.animateSummary
    ) {
      setTimeout(() => {
        this.onExpandToggle();
        this.props.animateSummaryProps.callback();
      }, 300);
    }
  };

  onExpandToggle = () => {
    this.props.handleSummaryToggle(!this.props.isSummaryOpen);
  };

  render() {
    let listPriceSum = 0;
    let salePriceSum = 0;
    let deltaSum = 0;
    let pricePerSfSum = 0;
    let marketTimeSum = 0;
    let avgListPrice = 0;
    let avgSalePrice = 0;
    let avgDelta = 0;
    let avgPricePerSf = 0;
    let avgMarketTime = 0;
    let sfSum = 0;
    let avgSf = 0;

    if (this.props.soldComps.length > 0) {
      for (let i = 0; i < this.props.soldComps.length; i += 1) {
        const item = this.props.soldComps[i];
        const salePrice = parseFloat(item.salePrice);
        const listPrice = parseFloat(item.listPrice);
        if (salePrice) {
          pricePerSfSum += salePrice / parseFloat(item.squareFeet);
          salePriceSum += salePrice;
        } else {
          pricePerSfSum += listPrice / parseFloat(item.squareFeet);
        }
        listPriceSum += listPrice;
        deltaSum += (salePrice - listPrice) / listPrice;
        marketTimeSum += parseInt(item.marketTime, 10);
        sfSum += parseInt(item.squareFeet, 10);
      }

      const count = this.props.soldComps.length;
      avgListPrice = Math.round(listPriceSum / count);
      avgSalePrice = Math.round(salePriceSum / count);
      avgDelta = deltaSum / count;
      avgPricePerSf = pricePerSfSum / count;
      avgMarketTime = Math.round(marketTimeSum / count);
      avgSf = Math.round(sfSum / count);
    }

    const infoList = () => {
      const list = [
        {
          title: 'List Price',
          value: `$${normalizePrice(avgListPrice)}`,
        },
        {
          title: 'Sale Price',
          value: `$${normalizePrice(avgSalePrice)}`,
        },
        {
          title: 'Price / sf',
          value: `$${normalizePrice(avgPricePerSf)}/sf`,
        },
        {
          title: 'Square Footage',
          value: `${normalizePrice(avgSf)} sf`,
        },
        {
          title: 'Days on Market',
          value: ` ${avgMarketTime}`,
        },
        {
          title: 'Number of Comps',
          value: ` ${this.props.soldComps.length}`,
        },
      ];
      return list;
    };

    const compsEmpty = this.props.soldComps.length === 0;
    const { classes } = this.props;
    const { expand, height } = this.state;
    const priceEstimate =
      avgPricePerSf * parseFloat(this.props.listing.squareFeet);
    if (isMobile()) {
      return (
        <AnimateHeight
          className={classes.mobileSummaryContainer}
          height={this.props.isSummaryOpen ? 310 : 75}
          onClick={this.onExpandToggle}
        >
          <div className={classes.spaceBetween}>
            <Typography className={classes.titleStyle}>
              Price Estimate
            </Typography>
            <Typography className={classes.titleStyle}>
              ${normalizePrice(priceEstimate)}
            </Typography>
          </div>
          <div className={classes.spaceBetween} style={{ margin: '5px 0' }}>
            <Typography
              className={classes.infoListStyle}
              style={{ fontSize: 12 }}
            >
              (Based on {this.props.soldComps.length} selected comps)
            </Typography>
            <Button
              className={classes.expandButtonStyle}
              onClick={(e: any) => {
                e.stopPropagation();
                this.onExpandToggle();
              }}
            >
              {expand ? <ExpandLess /> : <ExpandMore />}
            </Button>
          </div>
          <Typography className={classes.averages}>Averages</Typography>
          <div style={{ marginTop: 10 }}>
            {infoList().map((item: any, idex: number) => {
              return (
                <div
                  className={classes.spaceBetween}
                  style={{ margin: '7.5px 0' }}
                >
                  <Typography className={classes.infoListStyle}>
                    {item.title}
                  </Typography>
                  <Typography className={classes.infoListStyle}>
                    {item.value}
                  </Typography>
                </div>
              );
            })}
          </div>
        </AnimateHeight>
      );
    }
    return (
      <div className={`${style.summaryContainer} ${classes.summaryContainer}`}>
        <div className={style.listPreviewContainer}>
          <ListingPreview
            allowFavorite={false}
            cardFormat={false}
            listing={this.props.listing}
          />
        </div>
        <div className={style.summaryParent}>
          <div className={style.priceEstimate}>
            <div className={style.priceEstimateTitle}>Price Estimate</div>
            <span
              className="price-estimate-span"
              style={{
                color: compsEmpty ? '#323232' : '#195A50',
                fontSize: 36,
                fontWeight: 'bold',
              }}
            >
              {this.props.loading ? (
                <div className={classes.loader}>
                  <CircularProgress
                    size={40}
                    thickness={1}
                    variant="indeterminate"
                  />
                </div>
              ) : compsEmpty ? (
                '---'
              ) : (
                <NumberElement
                  val={priceEstimate}
                  prefix="$"
                  decimalScale={0}
                />
              )}
            </span>
            {!compsEmpty && !isNil(this.props.soldComps) && (
              <span>
                (Based on {this.props.soldComps.length} selected comp
                {this.props.soldComps.length > 1 ? 's' : ''})
              </span>
            )}
          </div>
          <div className={style.averages}>
            <span className="averages-span" style={{ textAlign: 'center' }}>
              Averages
            </span>
            <div className={style.averagesParent}>
              <div className={`${style.averagesItem} ${classes.topLeftItem}`}>
                <span className={style.subTitle}>List Price</span>
                {compsEmpty ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>
                    <NumberElement
                      decimalScale={0}
                      prefix="$"
                      val={avgListPrice}
                    />
                  </span>
                )}
              </div>
              <div className={`${style.averagesItem} ${classes.topMiddleItem}`}>
                <span className={style.subTitle}>Sale Price</span>
                {compsEmpty || avgSalePrice === 0 || !avgSalePrice ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>
                    <NumberElement
                      decimalScale={0}
                      prefix="$"
                      val={avgSalePrice}
                    />
                  </span>
                )}
              </div>
              <div className={`${style.averagesItem} ${classes.topRightItem}`}>
                <span className={style.subTitle}>Price Delta</span>
                {compsEmpty || avgSalePrice === 0 || isNaN(avgDelta) ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>
                    {percentage(avgDelta)}
                  </span>
                )}
              </div>

              <div
                className={`${style.averagesItem} ${classes.bottomLeftItem}`}
              >
                <span className={style.subTitle}>Price/sq ft</span>
                {compsEmpty || !avgPricePerSf ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>
                    <NumberElement
                      decimalScale={2}
                      prefix="$"
                      val={avgPricePerSf}
                    />
                  </span>
                )}
              </div>
              <div
                className={`${style.averagesItem} ${classes.bottomMiddleItem}`}
              >
                <span className={style.subTitle}>Square Footage</span>
                {compsEmpty || !avgSf ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>
                    <NumberElement decimalScale={0} val={avgSf} /> sq ft
                  </span>
                )}
              </div>
              <div
                className={`${style.averagesItem} ${classes.bottomRightItem}`}
              >
                <span className={style.subTitle}>Days on Market</span>
                {compsEmpty ? (
                  '-'
                ) : (
                  <span className={style.summaryValues}>{avgMarketTime}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Summary);
